export default "__VITE_ASSET__DyOY3_20__"